(function () {
  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function apiBase(root) {
    var endpoint = root.getAttribute('data-endpoint') || 'https://a.wahup.com/api/custom-shirts/popup/';
    return endpoint.replace(/\/popup\/?(?:\?.*)?$/, '/');
  }

  function buildUrl(root) {
    var endpoint = root.getAttribute('data-endpoint') || 'https://a.wahup.com/api/custom-shirts/popup/';
    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('shop', root.getAttribute('data-shop') || '');
    url.searchParams.set('path', root.getAttribute('data-path') || window.location.pathname);
    url.searchParams.set('_ts', String(Date.now()));
    return url.toString();
  }

  function openPopup(root) {
    root.hidden = false;
    document.documentElement.classList.add('wahup-custom-shirt-popup-open');
    var refresh = function () {
      if (root && typeof root.__wahupCustomShirtRefresh === 'function') root.__wahupCustomShirtRefresh();
    };
    window.requestAnimationFrame(function () { window.requestAnimationFrame(refresh); });
  }

  function closePopup(root) {
    root.hidden = true;
    document.documentElement.classList.remove('wahup-custom-shirt-popup-open');
    try { window.sessionStorage.setItem('wahup_custom_shirt_popup_closed', '1'); } catch (error) {}
  }

  function fallbackHtml() {
    return '<div class="wahup-custom-shirt-content"><p class="wahup-custom-shirt-eyebrow">Custom tee builder</p><h2 id="wahup-custom-shirt-popup-title">Create your custom shirt</h2><p class="wahup-custom-shirt-copy">The custom shirt builder is loading. Please try again in a moment.</p></div>';
  }

  function afterPageSettled(callback) {
    var run = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(callback, { timeout: 2500 });
      else window.setTimeout(callback, 250);
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function transformText(value, mode) {
    var text = String(value || '');
    if (mode === 'uppercase') return text.toUpperCase();
    if (mode === 'lowercase') return text.toLowerCase();
    if (mode === 'titlecase') return text.toLowerCase().replace(/\b\w/g, function (char) { return char.toUpperCase(); });
    return text;
  }

  var loadedFonts = {};
  function ensureFont(fontOrSlot) {
    var font = fontOrSlot && fontOrSlot.default_font ? fontOrSlot.default_font : fontOrSlot;
    if (!font || !font.font_url) return font ? (font.css_family || font.name) : '';
    var family = font.css_family || font.name;
    if (!loadedFonts[family]) {
      loadedFonts[family] = true;
      var style = document.createElement('style');
      style.textContent = '@font-face{font-family:"' + family.replace(/"/g, '') + '";src:url("' + font.font_url + '") format("truetype");font-display:swap;}';
      document.head.appendChild(style);
    }
    return family;
  }

  function designPayload(template, mockup) {
    var region = (mockup && mockup.design_region) || (template && template.design_region) || {};
    var design = region && region.design && Array.isArray(region.design.layers) ? region.design : null;
    if (!design && template && template.design_region && template.design_region.design && Array.isArray(template.design_region.design.layers)) design = template.design_region.design;
    return design || null;
  }

  function editableFields(template, mockup) {
    var design = designPayload(template, mockup);
    if (design && Array.isArray(design.layers) && design.layers.some(function (layer) { return layer && layer.type !== 'image'; })) {
      return (design.layers || []).filter(function (layer) { return layer && layer.type !== 'image'; }).map(function (layer, index) {
      return {
        field_type: 'layer',
        field_id: 'layer_' + layer.id,
        layer_id: layer.id,
        id: layer.id,
        label: layer.label || ('Text ' + (index + 1)),
        placeholder: layer.text || 'Custom text',
        default_text: layer.text || '',
        max_length: 60,
        text_transform: 'none'
      };
      });
    }
    if (template && Array.isArray(template.text_slots) && template.text_slots.length) {
      return template.text_slots.map(function (slot) { return Object.assign({ field_type: 'slot', field_id: 'slot_' + slot.id }, slot); });
    }
    return [];
  }

  function fieldText(field, form) {
    var input = null;
    if (field.field_type === 'layer') input = form && form.querySelector('[data-layer-id="' + CSS.escape(String(field.layer_id)) + '"]');
    else input = form && form.querySelector('[name="slot_' + field.id + '"]');
    return transformText(input ? input.value : field.default_text || field.placeholder || field.label, field.text_transform);
  }

  function layerText(layer, fields, form) {
    var field = fields.find(function (item) { return item.field_type === 'layer' && String(item.layer_id) === String(layer.id); });
    return field ? fieldText(field, form) : (layer.text || 'Text');
  }

  function renderTextPath(layer, text, fontSizePx) {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'wahup-custom-shirt-text-svg');
    svg.setAttribute('viewBox', '0 0 100 32');
    svg.setAttribute('preserveAspectRatio', 'none');
    var defs = document.createElementNS(svgNS, 'defs');
    var path = document.createElementNS(svgNS, 'path');
    var id = 'wahup-text-path-' + String(layer.id || Math.random()).replace(/[^a-z0-9_-]/gi, '');
    var strength = Math.max(0, Math.min(2, Number(layer.textPathStrength || 1)));
    var curve = 16 * strength;
    var d = 'M5 22 Q50 ' + (22 - curve) + ' 95 22';
    if (layer.textPath === 'arc-down') d = 'M5 10 Q50 ' + (10 + curve) + ' 95 10';
    if (layer.textPath === 'wave') d = 'M5 18 C25 ' + (18 - curve) + ', 35 ' + (18 + curve) + ', 50 18 S75 ' + (18 - curve) + ', 95 18';
    path.setAttribute('id', id);
    path.setAttribute('d', d);
    defs.appendChild(path);
    svg.appendChild(defs);
    var svgText = document.createElementNS(svgNS, 'text');
    svgText.setAttribute('fill', 'currentColor');
    svgText.setAttribute('font-family', layer.fontFamily || 'Georgia');
    svgText.setAttribute('font-size', Math.max(8, fontSizePx));
    svgText.setAttribute('letter-spacing', String(Number(layer.letterSpacing || 0)));
    svgText.setAttribute('dominant-baseline', 'middle');
    var textPath = document.createElementNS(svgNS, 'textPath');
    textPath.setAttribute('href', '#' + id);
    textPath.setAttribute('startOffset', layer.align === 'left' ? '0%' : layer.align === 'right' ? '100%' : '50%');
    textPath.setAttribute('text-anchor', layer.align === 'left' ? 'start' : layer.align === 'right' ? 'end' : 'middle');
    textPath.textContent = text;
    svgText.appendChild(textPath);
    svg.appendChild(svgText);
    return svg;
  }

  function renderDesignLayer(layer, design, fields, form, host) {
    var el = document.createElement('div');
    el.className = 'wahup-custom-shirt-text-slot wahup-custom-shirt-design-layer';
    el.style.left = (Number(layer.x || 50) - Number(layer.width || 60) / 2) + '%';
    el.style.top = (Number(layer.y || 50) - Number(layer.height || 12) / 2) + '%';
    el.style.width = Number(layer.width || 60) + '%';
    el.style.height = Number(layer.height || 12) + '%';
    el.style.zIndex = Number(layer.zIndex || 10);
    el.style.transform = 'rotate(' + Number(layer.rotation || 0) + 'deg) scale(' + (Math.max(10, Math.min(300, Number(layer.scale || 100))) / 100) + ')';
    if (layer.type === 'image' && layer.src) {
      var img = document.createElement('img');
      img.src = layer.src;
      img.alt = '';
      el.className = 'wahup-custom-shirt-design-image';
      el.appendChild(img);
      return el;
    }
    var hostWidth = Math.max(1, host.clientWidth || 520);
    var designWidth = Math.max(1, Number(design.width || 1024));
    var fontSizePx = Math.max(8, Number(layer.fontSize || 72) / designWidth * hostWidth);
    el.style.color = layer.color || '#111111';
    el.style.fontSize = fontSizePx + 'px';
    el.style.fontFamily = '"' + String(layer.fontFamily || 'Georgia').replace(/"/g, '') + '", Georgia, serif';
    el.style.letterSpacing = Number(layer.letterSpacing || 0) + 'px';
    el.style.textAlign = layer.align || 'center';
    var text = layerText(layer, fields, form);
    if (layer.textPath && layer.textPath !== 'none') el.appendChild(renderTextPath(layer, text, fontSizePx));
    else el.textContent = text;
    return el;
  }

  function renderPreview(template, mockup, form, root) {
    var image = root.querySelector('[data-preview-mockup], [data-inline-preview-image]');
    var layerHost = root.querySelector('[data-preview-slots], [data-inline-preview-slots]');
    if (!image || !layerHost || !mockup) return;
    image.src = mockup.image_url || '';
    layerHost.innerHTML = '';
    var fields = editableFields(template, mockup);
    var design = designPayload(template, mockup);
    if (design && Array.isArray(design.layers) && design.layers.length) {
      design.layers.slice().sort(function (a, b) { return Number(a.zIndex || 0) - Number(b.zIndex || 0); }).forEach(function (layer) {
        layerHost.appendChild(renderDesignLayer(layer, design, fields, form, layerHost));
      });
      return;
    }
    fields.forEach(function (slot) {
      var box = slot.box || {};
      var x = Number(box.x || 50), y = Number(box.y || 50), w = Number(box.width || 60), h = Number(box.height || 12);
      var el = document.createElement('div');
      el.className = 'wahup-custom-shirt-text-slot';
      el.style.left = (x - w / 2) + '%';
      el.style.top = (y - h / 2) + '%';
      el.style.width = w + '%';
      el.style.height = h + '%';
      el.style.zIndex = Number(box.z_index || 10);
      el.style.transform = 'rotate(' + Number(box.rotation || 0) + 'deg)';
      el.style.color = slot.default_color || '#111111';
      el.style.fontSize = Math.max(12, Number(box.font_size || 36)) + 'px';
      var fontFamily = ensureFont(slot);
      if (fontFamily) el.style.fontFamily = '"' + fontFamily.replace(/"/g, '') + '", Georgia, serif';
      el.style.letterSpacing = Number(slot.letter_spacing || 0) + 'px';
      el.style.lineHeight = Number(slot.line_height || 1);
      el.style.opacity = Math.max(0, Math.min(1, Number(slot.opacity || 1)));
      el.textContent = fieldText(slot, form);
      layerHost.appendChild(el);
    });
  }

  function renderTextFields(container, template, mockup) {
    var fields = editableFields(template, mockup);
    container.innerHTML = fields.map(function (field) {
      var value = field.default_text || field.placeholder || '';
      if (field.field_type === 'layer') {
        return '<label class="wahup-custom-shirt-label" for="' + escapeHtml(field.field_id) + '">' + escapeHtml(field.label) + '</label>' +
          '<input id="' + escapeHtml(field.field_id) + '" name="' + escapeHtml(field.field_id) + '" data-layer-id="' + escapeHtml(field.layer_id) + '" data-slot-label="' + escapeHtml(field.label) + '" maxlength="' + (field.max_length || 60) + '" placeholder="' + escapeHtml(field.placeholder || field.label) + '" value="' + escapeHtml(value) + '">';
      }
      return '<label class="wahup-custom-shirt-label" for="slot_' + field.id + '">' + escapeHtml(field.label) + '</label>' +
        '<input id="slot_' + field.id + '" name="slot_' + field.id + '" maxlength="' + (field.max_length || 40) + '" placeholder="' + escapeHtml(field.placeholder || field.label) + '" value="' + escapeHtml(value) + '">';
    }).join('');
  }

  function initBuilder(root) {
    var data = document.getElementById('wahup-custom-shirt-template-data');
    if (!data) return;
    var templates = [];
    try { templates = JSON.parse(data.textContent || '[]'); } catch (error) { templates = []; }
    var picker = root.querySelector('[data-template-picker]');
    var builder = root.querySelector('[data-template-builder], [data-inline-shirt-builder]');
    var title = root.querySelector('[data-builder-title]');
    var subtitle = root.querySelector('[data-builder-subtitle]');
    var colorOptions = root.querySelector('[data-color-options], [data-inline-color-options]');
    var textFields = root.querySelector('[data-text-fields]');
    var form = root.querySelector('[data-shirt-form], [data-inline-shirt-form]');
    var status = root.querySelector('[data-shirt-status]');
    var activeTemplate = null;
    var activeMockup = null;
    if (form) { form.removeAttribute('onsubmit'); form.onsubmit = null; }
    root.__wahupCustomShirtRefresh = function () {
      if (activeTemplate && activeMockup) renderPreview(activeTemplate, activeMockup, form, root);
    };

    function selectTemplate(template) {
      activeTemplate = template;
      activeMockup = (template.mockups || []).find(function (mockup) { return mockup.is_default; }) || (template.mockups || [])[0] || null;
      if (title) title.textContent = template.name;
      if (form) form.setAttribute('data-template-id', template.id);
      if (subtitle) subtitle.textContent = (template.product_type || '').replace(/_/g, ' ') + ' · ' + (template.mockups || []).length + ' colors';
      if (colorOptions) {
        colorOptions.innerHTML = (template.mockups || []).map(function (mockup, index) {
          var active = activeMockup && String(activeMockup.id) === String(mockup.id) ? ' is-active' : '';
          return '<label class="wahup-custom-shirt-color' + active + '" data-mockup-id="' + mockup.id + '">' +
            '<input type="radio" name="mockup_id" value="' + mockup.id + '" ' + (index === 0 ? 'checked' : '') + '>' +
            (mockup.image_url ? '<img src="' + mockup.image_url + '" alt="" loading="lazy" decoding="async">' : '') +
            '<span>' + escapeHtml(mockup.color_name || 'Color') + '</span></label>';
        }).join('');
      }
      if (textFields) renderTextFields(textFields, template, activeMockup);
      if (picker) picker.hidden = true;
      if (builder && builder.hasAttribute('data-template-builder')) builder.hidden = false;
      root.querySelectorAll('[data-mockup-id]').forEach(function (button) {
        button.classList.toggle('is-active', activeMockup && String(activeMockup.id) === button.getAttribute('data-mockup-id'));
      });
      root.__wahupCustomShirtRefresh();
    }

    root.querySelectorAll('[data-template-id]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-template-id');
        var template = templates.find(function (item) { return String(item.id) === String(id); });
        if (template) selectTemplate(template);
      });
    });

    root.querySelector('[data-template-back]')?.addEventListener('click', function () {
      if (builder) builder.hidden = true;
      if (picker) picker.hidden = false;
    });

    colorOptions?.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mockup-id]');
      if (!button || !activeTemplate) return;
      activeMockup = (activeTemplate.mockups || []).find(function (mockup) { return String(mockup.id) === button.getAttribute('data-mockup-id'); }) || activeMockup;
      colorOptions.querySelectorAll('[data-mockup-id]').forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      var radio = button.querySelector('input[name="mockup_id"]');
      if (radio) radio.checked = true;
      if (textFields) renderTextFields(textFields, activeTemplate, activeMockup);
      root.__wahupCustomShirtRefresh();
    });

    form?.addEventListener('input', function () {
      root.__wahupCustomShirtRefresh();
    });

    form?.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!activeTemplate || !activeMockup) return;
      if (status) status.textContent = 'Saving preview...';
      var fields = editableFields(activeTemplate, activeMockup);
      var texts = fields.map(function (field) {
        return { slot_id: field.id, layer_id: field.layer_id || '', label: field.label, text: fieldText(field, form) };
      });
      var sizeEl = form.querySelector('select[name="size"]');
      var size = sizeEl ? sizeEl.value : '';
      fetch(apiBase(root) + 'preview/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        mode: 'cors',
        body: JSON.stringify({ template_id: activeTemplate.id, mockup_id: activeMockup.id, texts: texts, size: size })
      })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          if (!payload.ok) throw new Error(payload.error || 'Preview failed');
          if (status) status.textContent = 'Saved. Draft #' + payload.draft_id + ' is ready.';
        })
        .catch(function (error) { if (status) status.textContent = error.message || 'Could not save preview.'; });
    });

    if (builder && templates.length) selectTemplate(templates[0]);
  }

  function preparePopupHtml(root, body, html) {
    body.innerHTML = html || fallbackHtml();
    body.querySelectorAll('img').forEach(function (image) { image.loading = image.loading || 'lazy'; image.decoding = 'async'; });
    initBuilder(root);
  }

  ready(function () {
    var root = document.getElementById('wahup-custom-shirt-popup-root');
    if (!root) return;
    try { if (window.sessionStorage.getItem('wahup_custom_shirt_popup_closed') === '1') return; } catch (error) {}
    root.querySelectorAll('[data-custom-shirt-close]').forEach(function (button) { button.addEventListener('click', function () { closePopup(root); }); });
    var delay = parseInt(root.getAttribute('data-delay-ms') || '3000', 10);
    window.setTimeout(function () {
      afterPageSettled(function () {
        var body = root.querySelector('[data-custom-shirt-body]');
        var controller = 'AbortController' in window ? new AbortController() : null;
        var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 3500) : null;
        fetch(buildUrl(root), { credentials: 'omit', mode: 'cors', cache: 'no-store', signal: controller ? controller.signal : undefined })
          .then(function (response) { if (!response.ok) throw new Error('HTTP ' + response.status); return response.json(); })
          .then(function (payload) {
            if (timeout) window.clearTimeout(timeout);
            preparePopupHtml(root, body, payload && payload.html ? payload.html : fallbackHtml());
            openPopup(root);
          })
          .catch(function () {
            if (timeout) window.clearTimeout(timeout);
            preparePopupHtml(root, body, fallbackHtml());
            openPopup(root);
          });
      });
    }, Number.isFinite(delay) ? delay : 3000);
  });
})();
